<div class="favorites-container">
  <div class="header">
    <h1>Meine Favoriten</h1>
  </div>

  @if (favoriteStops$ | async; as stops) {
    @if (stops.length > 0) {
      <mat-list>
        @for (stop of stops; track stop.id) {
          <mat-list-item (click)="showOnMap(stop)">
            <mat-icon matListItemIcon>star</mat-icon>
            <div matListItemTitle>{{ stop.name }}</div>
            <div matListItemLine>{{ stop.autobahn }}</div>
          </mat-list-item>
          <mat-divider></mat-divider>
        }
      </mat-list>
    } @else {
      <div class="empty-state">
        <mat-icon>favorite_border</mat-icon>
        <p>Du hast noch keine Favoriten gespeichert.</p>
        <span>Klicke auf das Herz-Symbol bei einer Raststätte, um sie hier hinzuzufügen.</span>
      </div>
    }
  }
</div>
